import { useEffect, useState } from 'react';
import { useErrorBoundary } from 'react-error-boundary';
import Main from '../../../layouts/Main';
import Container from '../../../components/Container';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import {Box, Button, Card, Divider, Grid2 as Grid, Stack, Typography, useMediaQuery} from '@mui/material';
import PageBreadcrumbs from '../../../components/PageBreadcrumbs';
import { useTheme } from '@mui/material/styles';
import { SearchDocument } from '../../../types/search/searchDocument';
import { GetSearchDocumentTypeTag } from '../../../utility/getSearchDocumentTypeTag';


const ViewDocument = (): JSX.Element => {

    const theme = useTheme(); 
    const isSM = useMediaQuery(theme.breakpoints.down('sm')); 
    const { showBoundary } = useErrorBoundary(); 
    const queryParams = new URLSearchParams(window.location.search);
    const documentId = queryParams.get('id') || queryParams.get('docId') || 0;
    const [document, setDocument] = useState<SearchDocument>();

    useEffect(() => {
        getDocument();
    }, [])
    
    const getDocument = async () => {
    
        try{
              await fetch(`${process.env.REACT_APP_API_BASE_URL}/public/search/document/${documentId}`)
              .then(result => {
                if (!result.ok) {
                  showBoundary(new Error(`Failed to get the requested document with id ${documentId}.`));
                }
                return result.json();
              })
              .then(result => {
                setDocument(result);
              });
        }catch(error){
            console.error('Uncaught Error:', error);
            showBoundary(new Error(`${error}`));
        }
    }

    const getEmbededVideoUrl = (url: string)=> {
        const regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/;
        const match = url.match(regExp);
        return (match && match[2].length === 11)? match[2]: null;
      }

    const copyDocumentLink = () => {
        navigator.clipboard.writeText(window.location.href);
        alert('The link of this document is copied');
    }

    return (
        <Main>
        <Container>
            <PageBreadcrumbs></PageBreadcrumbs>
            <Box marginBottom={0} marginTop={3}>
                <Stack direction={'row'} spacing={1} marginBottom={1} alignItems={'left'}>
                    {document?.documentTypeId !== undefined && GetSearchDocumentTypeTag(document.documentTypeId)}
                    <Typography component={'i'} variant='caption' color="text.secondary" marginTop={3} >
                        {document?.date}
                    </Typography>
                </Stack>
                <Typography fontWeight={550} variant='h6' color="primary">{document?.code} {document?.title}</Typography>             
            </Box>
            <Box marginBottom={1} display={'flex'} justifyContent={'right'} marginRight={3}>
                <Button size="small" startIcon={<ContentCopyIcon />} onClick={copyDocumentLink}>
                    Copy Link
                </Button>
             </Box>
            <Divider/>
            <Grid container marginTop={3}>
              {
                document?.description &&
                <Grid 
                    padding={3}
                    size={12}
                    component={Card}
                    boxShadow={1}
                    marginBottom={3}
                >
                    <Typography variant='subtitle1' fontWeight={550} marginBottom={2}>Summary</Typography>
                    <Typography color="text.secondary"><p dangerouslySetInnerHTML={{ __html: document?.description || '' }} /></Typography>  
                </Grid>
              }
              {
                document?.content &&
                <Grid 
                    padding={3}
                    size={12}
                    component={Card}
                    boxShadow={1}
                    marginBottom={3}
                >
                    <Typography variant='subtitle1' fontWeight={550} marginBottom={2}>Full Text</Typography>
                    <Typography><p dangerouslySetInnerHTML={{ __html: document?.content || '' }} /></Typography>  
                </Grid>
              }
              {
                    document?.documentTypeId === 65 &&
                    <Grid 
                        height={{xs: 300, md: 500}}
                        padding={3}
                        size={12}
                        component={Card}
                        boxShadow={1}
                    >
                        <iframe 
                            height={"100%"}
                            width={isSM? "100%": "65%"}
                            src={`https://www.youtube.com/embed/${getEmbededVideoUrl(document.url)}`} 
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share">
                        </iframe>
                    </Grid>
                }   
            </Grid>
        </Container>
      </Main>
  );
};

export default ViewDocument;